import { OptionType } from 'spa/member/components/Select/types'

export const generateHoursPerWeekOptions = (min: number, max: number, step: number, unit: string = ''): OptionType[] => {
  const numberOptions = Array.from({ length: (max - min) / step + 1 }, (_, i) => {
    const number = min + i * step

    return {
      label: `${number}${unit}`,
      value: number.toString()
    }
  })

  return [{ label: '選択してください', value: '' }, { label: `${min - 1}時間以下`, value: `${min - 1}` }, ...numberOptions]
}
